import { render, staticRenderFns } from "./marketing_record.vue?vue&type=template&id=47cfaf6e&scoped=true"
import script from "./marketing_record.vue?vue&type=script&lang=js"
export * from "./marketing_record.vue?vue&type=script&lang=js"
import style0 from "./marketing_record.vue?vue&type=style&index=0&id=47cfaf6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cfaf6e",
  null
  
)

export default component.exports